import { FormattedMessage } from 'react-intl'

import { ClickableInformation } from '@components/UI/Information'
import InformationContent from '@components/UI/Information/Content/Content'
import { BRAND_MATCH_EDUCATION } from '@constants'
import Theme from '@theme'
import { Container, Link, Text } from '@tribegroup'

export const InfluencerIdentityLabelsBrandMatchScore = ({
  brandMatchScore,
}: {
  brandMatchScore?: number | null
}) => {
  if (typeof brandMatchScore !== 'number') {
    return null
  }

  return (
    <ClickableInformation
      stopEventPropagation
      width={18.125}
      leftOffset={5.5}
      target={
        <Container
          innerSpacing={0.1875}
          flexCenter
          borderColor={Theme.primary100Color}
          borderWidth={0.0625}
          borderRadius={0.25}
          borderStyle="solid"
        >
          <Text uppercase light xxsmall color={Theme.primaryColor}>
            <FormattedMessage
              id="submission.card.action.header.brandMatchPct"
              values={{ brandMatchPct: brandMatchScore }}
            />
          </Text>
        </Container>
      }
    >
      <InformationContent
        title={<FormattedMessage id="core.text.brandMatchPct" />}
        content={
          <>
            <Container bottomOuterSpacing={0.5}>
              <FormattedMessage id="submission.card.action.header.brandMatchPct.tooltip.first" />
            </Container>
            <FormattedMessage id="submission.card.action.header.brandMatchPct.tooltip.second" />

            <Container topOuterSpacing={0.75}>
              <Link href={BRAND_MATCH_EDUCATION} target="_blank" color={Theme.secondaryColor}>
                <Text color={Theme.primaryColor}>
                  <FormattedMessage id="core.text.learnMore.withArrow" />
                </Text>
              </Link>
            </Container>
          </>
        }
      />
    </ClickableInformation>
  )
}
